import { ReduxService } from 'dashboard-services/services';

import { pythonEditorActions } from 'actions/modules/tools';

export const pythonEditorInitialState = {
  id: undefined,
  isOpen: false,
  editable: true,

  provider: undefined,
  onSubmitCallback: undefined,
  taskId: undefined,
  groupName: undefined,
  jobId: undefined,
  newFile: false,
}

export default (state = pythonEditorInitialState, action) => {

  switch (action.type) {
    case pythonEditorActions.CHANGE_VALUE: {
      if(state[action.name] !== action.value) {
        return ReduxService.updateObject(state, { [action.name]: action.value })
      }
      return state;
    }
    case pythonEditorActions.CLEAR: {
      return pythonEditorInitialState;
    }
    default:
      return state;
  }
}